import ClientesEmRisco from 'components/relatorios/clientes-em-risco';
import CardsAcoesLojas from 'components/relatorios/cards-acoes-lojas';
import OportunidadesDeVenda from 'components/relatorios/oportunidades-de-venda';
import DesempenhoDiario from 'components/relatorios/desempenho-diario';
import React, { useState, useEffect } from 'react';
import lib from 'helpers/lib';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

export default function AcoesLojas({representadas, vendedores}){

  const mesInicialFiltro = new Date(),
    y = mesInicialFiltro.getFullYear(),
    m = mesInicialFiltro.getMonth();
  const [isLoading, setIsLoading] = useState(false);

  const [filter, setFilter] = React.useState({
      mes: m + 1,
      ano: y,
      representadaId: null,
      vendedorId: null
    });

  const [loadedRepresentadas, setLoadedRepresentadas] = React.useState(false);
  const [loadedVendedores, setLoadedVendedores] = React.useState(false);
  const [triggerFilters, setTriggerFilters] = React.useState(false);
  
    useEffect(() => {
      (async () => {
        if (vendedores) {
          if (vendedores.length === 1) {
            setFilter((prevFilter) => ({
              ...prevFilter,
              vendedorId: vendedores[0]?.value
            }));
          }
          setLoadedVendedores(true);
        }
      })();
    }, [vendedores]);
  
    useEffect(() => {
      (async () => {
        if (representadas && representadas.length > 0) {
          setFilter((prevFilter) => ({
            ...prevFilter,
            representadaId: representadas[0]?.value
          }));
  
          setLoadedRepresentadas(true);
        }
      })();
    }, [representadas]);
  
    useEffect(() => {
      (async () => {
        if (loadedRepresentadas && loadedVendedores) {
          // Fetch data
          setTriggerFilters(true);
        }
      })();
    }, [loadedRepresentadas, loadedVendedores]);

  return(
    <div className="col-12 relatorio-home">
      <div className="form-clientes pt-3">
        <div className="row align-items-end">
          {/* Representada ---------------------------------------------------------------------- */}
          <div className="col-lg-3 mb-3" disabled>
            <label>Representada</label>
            <Select
              className="select-form-control "
              classNamePrefix="react-select-index"
              options={representadas}
              value={filter.representadaId ? representadas?.find((item) => item.value === filter.representadaId) : null}
              isClearable={false}
              onChange={(options) => setFilter({ ...filter, representadaId: options?.value })}
              placeholder="Selecione..."
            />
          </div>

          <div className="col-lg-3 mb-3">
            <label>Vendedor</label>
            <Select
              isClearable={vendedores?.length > 1}
              clearValue={() => {
                setFilter({ ...filter, vendedorId: null });
              }}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={vendedores}
              value={vendedores?.find((x) => x.value === filter.vendedorId)}
              onChange={(selectedValue) => {
                setFilter({ ...filter, vendedorId: selectedValue?.value });
              }}
            />
          </div>

          <div className="col-lg-2 mb-3">
            <label>Mês</label>
            <Select
              className="select-form-control "
              classNamePrefix="react-select-index"
              value={lib.selectListMeses?.find((item) => item.value === filter.mes)}
              options={lib.selectListMeses}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, mes: item.value });
              }}
              placeholder="Selecione..."
            />
          </div>

          <div className="col-lg-2 mb-3">
            <label>Ano</label>
            <Select
              className="select-form-control "
              classNamePrefix="react-select-index"
              value={lib.selectListAnos?.find((item) => item.value === filter.ano)}
              options={lib.selectListAnos}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, ano: item.value });
              }}
              placeholder="Selecione..."
            />
          </div>

          <div className="col-lg-2 text-center align-items-center pt-3 pt-lg-0  mb-3">
            <button
              type="button"
              className="btn btn-secondary btn-action w-100"
              onClick={async () => {
                // setIsLoading(true);
                setTriggerFilters(true);
              }}
              disabled={isLoading}
            >
              <FontAwesomeIcon icon={faFilter} /> Filtrar
            </button>
          </div>
        </div>
      </div>

      <hr />

      <div className='row mt-3'>
        <div className="col-12">
          <DesempenhoDiario 
            representadaId={filter.representadaId}
            vendedorId={filter.vendedorId}
            mes={filter.mes}
            ano={filter.ano}
            triggerFilters={triggerFilters}
            onDoneFiltering={() => { setTriggerFilters(false); setIsLoading(false); }}
          />
        </div>

        {/* <div className="col-12 mt-4">
          <CardsAcoesLojas />
        </div>

        <div className="col-6">
          <ClientesEmRisco triggerFilters={triggerFilters} onDoneFiltering={() => { setTriggerFilters(false); setIsLoading(false); }}/>
        </div>

        <div className="col-6">
          <OportunidadesDeVenda />
        </div> */}
      </div>
    </div>
  );
}